import { render, staticRenderFns } from "./TablePayPage.vue?vue&type=template&id=2940a6b2&scoped=true"
import script from "./TablePayPage.vue?vue&type=script&lang=js"
export * from "./TablePayPage.vue?vue&type=script&lang=js"
import style0 from "./TablePayPage.vue?vue&type=style&index=0&id=2940a6b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2940a6b2",
  null
  
)

export default component.exports